import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {ConfigProvider} from 'antd';

import 'antd/dist/antd.variable.css';
import './assets/styles/main.css';
import './assets/styles/responsive.css';

import SignIn from './pages/SignIn';
import ProtectedRoutes from './ProtectedRoutes';
import AppContainer from './components/AppContainer';
import LoaderComponent from './components/Loader';
import {useAuth} from './context/AuthContext'; // We'll read user/roles from context

ConfigProvider.config({
    theme: {
        primaryColor: '#420085', // #420085, #a448ff
        errorColor: '#ff6f50',
    },
});

function App() {
    const {user, loading} = useAuth();

    if (loading) {
        return <LoaderComponent/>;
    }

    return (
        <ConfigProvider>
            <div className="App">
                {!loading && (
                    <div style={{flexGrow: 1}}>
                        <Switch>
                            <Route path="/sign-in" exact component={SignIn}/>
                            <ProtectedRoutes path="/" component={AppContainer} user={user}/>
                            <Redirect from="*" to="/users"/>
                        </Switch>
                    </div>
                )}
                {loading && <LoaderComponent/>}
            </div>
        </ConfigProvider>
    );
}

export default App;
